'use client';

import { useLoyaltyService, useUser } from '@skin-seoul/service';
import { LoyaltyPointsBanner } from './LoyaltyPointsBanner';
import { LoyaltyPointsBannerSkeleton } from './LoyaltyPointsBannerSkeleton';
import { LoyaltyPointsSignUpBanner } from './LoyaltyPointsSignUpBanner';
export const LoyaltyPointsBannerContainer = () => {
  const {
    user,
    isAuthenticated,
    isLoading: isUserLoading
  } = useUser();
  const {
    useGetCustomerBalance
  } = useLoyaltyService();
  const {
    data: balanceData,
    isLoading: isBalanceLoading
  } = useGetCustomerBalance({
    customerId: String(user?.userId ?? ''),
    enabled: isAuthenticated && Boolean(user?.userId)
  });

  // Show skeleton while loading user or balance data
  if (isUserLoading || isBalanceLoading) {
    return <LoyaltyPointsBannerSkeleton />;
  }

  // Show sign up banner if not authenticated or no data
  if (!isAuthenticated || !user?.userId || !balanceData) {
    return <LoyaltyPointsSignUpBanner />;
  }

  // Show actual points banner
  return <LoyaltyPointsBanner points={balanceData.availablePoints} data-sentry-element="LoyaltyPointsBanner" data-sentry-component="LoyaltyPointsBannerContainer" data-sentry-source-file="LoyaltyPointsBannerContainer.tsx" />;
};